<template>
  <div>"{{ quote }}"</div>
</template>

<script>
// import db from '../db.js'; TODO - Pull quotes from DB, not component
// import util from '../util.js';

export default {
  name: "quotes",
  computed: {
    quote() {
      let quotes = [
        "You don't get what you say you want, you get what you commit to.",
        "Every big success is the result of a series of smaller accomplishments. Don't become discouraged if you're not where you want to be. Progress is made one step at a time.",
        "When motivation ceases, let discipline take over.",
        "Don't give up what you want most, for what you want now.",
        "Obsessed is just a word the lazy use to describe the dedicated.",
        "Do something today that your future self will thank you for.",
        "If you don't build your dreams, someone else will hire you to build theirs.",
        "Is what you're doing today getting you closer to where you want to be tomorrow?",
        "You can't get much done in life if you only work on the days you feel like it.",
        "When life gives you lemons, make orange juice and leave the world wondering how you did it.",
        "A comfort zone is a beautiful place, but nothing ever grows there.",
        "Don't think about what can happen in a month. Don't think about what can happen in a year. Just focus on the 24 hours in front of you and do what you can to get closer to where you want to be.",
        "We must all suffer one of two things: the pain of discipline or the pain or regret.",
        "Success is the sum of small efforts repeated day in and day out.",
        "Motivation is what gets you started, habit is what keeps you going.",
        "Be so good they can't ignore you.",
        "Working hard for something we don't care about is called stress. Working hard for something we love is called passion.",
        "Success is never final, failure is never fatal, it's courage that counts.",
        "Success seems to be connected with action. Successful people keep moving. They make mistakes but they don't quit.",
        "There is no elevator to success. You have to take the stairs.",
        "Everything worth doing takes time.",
        "A river cuts through rock, not because of its power, but because of its persistence.",
        "Every morning, you have two choices: continue to sleep with your dreams, or wake up and chase them.",
        "A ship in harbor is safe, but that's not why ships are built.",
        "Don't practice until you get it right. Practice until you can't get it wrong.",
        "Success consists of going from failure to failure without loss of enthusiasm.",
        "With self-discipline, almost anything is possible.",
        "If we wait until we're ready, we'll be waiting for the rest of our lives.",
        "If you're not making mistakes, you're not pushing yourself hard enough.",
        "The only time you grow, the only time you get better, is when you hit that point of wanting to quit and you keep going instead",
        "The greatest mistake you can make in life is to continually fear you will make one.",
        "We suffer more often in imagination than in reality.",
        "Enthusiasm finds the target. Discipline paves the road.",
        "Falling down is part of life. Getting back up is living.",
        "No matter how slow you go, you are still lapping everybody on the couch.",
        "You're not going to master the rest of your life in one day. Just relax. Master the day. Then just keep doing that every day.",
        "Just Do It.",
        "Don't wait until you've reached your goal to be proud of yourself. Be proud of every step you take towards reaching your goal!",
        "We are what we repeatedly do.",
        "Set deadlines, work hard, make progress, and take chances!",
        "You get what you focus on so focus on what you want.",
        "Ease is a greater threat to progress than hardship.",
        "One day at a time.",
        "Don't be afraid to fail. Be afraid not to try.",
        "Stay positive!",
        "Don't think about what can happen in a month. Don't think about what can happen in a year. Just focus on the 24 hours in front of you and do what you can to get closer to whree you want to be.",
        "Do the hard things anyways!",
        "We are what we repeatedly do. Excellence then, is not an act, but a habit",
        "Greatness and comfort rarely coexist.",
        "What would you do if you weren't afraid?",
        "Done is better than perfect.",
        "If you want to be world-class, you have to invest in yourself.",
        "Once you truly know that every problem can be solved by breaking it down into smaller pieces, nothing can stop you.",
        "Stop being afraid of what could go wrong, and start being excited about what could go right!",
        "When something is important enough, you do it even if the odds are not in your favor.",
        "Success is worth working for.",
        "You don't have to be great to start, but you have to start to be great.",
        "Patience, persistence, and perspiration make an unbeatable combination for success.",
        "Hard work is a two-way street. You get back exactly what you put in.",
        "Sometimes it's the smallest decisions that can change your life forever.",
        "Carve your own path.",
        "Nothing ventured, nothing gained.",
        "You miss 100% of the shots you don't take.",
        "The difference between ordinary and extraordinary is that little extra.",
        "Stop worrying about what you have to lose and start focusing on what you have to gain!",
        "Make great things happen!",
        "Only put off until tomorrow what you are willing to die having left undone.",
        "The way to get started is to quit talking and begin doing.",
        "Never give up.",
        "The best time to start was yesterday. The next best time is now.",
        "Yesterday you said tomorrow.",
        "Life begins at the end of your comfort zone.",
        "Do it for the future you.",
        "When you feel like quitting, remember why you started.",
      ];

      return quotes[Math.floor(Math.random() * quotes.length)];
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// Quotes.vue?1d019bc6